import axios from "axios";

import { BACKEND_URL } from "config";

export async function createStripeCheckoutSessionAndRedirect() {
    try {
      const response = await axios.post(`${BACKEND_URL}stripe/create-checkout-session`, { 
        lookup_key: "basic" 
      });

      window.location.replace(response.data.url);
  } catch (e) {
    console.error(e);
  }
};

export async function getStripeCheckoutSession({ sessionId }) {
  try { 
    const response = await axios.post(`${BACKEND_URL}stripe/get-checkout-session`, {sessionId});

    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export async function getStripePortalSessionAndRedirect({ customerId}) {
  try {
    const response = await axios.post(`${BACKEND_URL}stripe/create-portal-session`, {customerId});

    window.location.replace(response.data.url);
  } catch (e) {
    console.error(e);
  }
}

export async function checkUserSubscription({ customerId }) {
  try {
    const response = await axios.post(`${BACKEND_URL}stripe/check-subscription`, {customerId});

    return response.data;
  } catch (e) {
    return { doesUserHaveActiveSubscription: false }
  }
};
